// extracted by mini-css-extract-plugin
export default {"page":"page__M0769","title":"title__eg-WX","subtitle":"subtitle__SvpKz","content":"content__RNxbl"};